import { useState } from "react";
import { useDispatch } from "react-redux";
import { FaTrash } from "react-icons/fa";
import { IoIosAlert } from "react-icons/io";

import { AIAction } from "../../store/actions";

import { Modal, Buttons, Loader } from "../../components";
import { Images } from "../../config";

const VisionAISidebar = ({
  chat = [],
  activeSession,
  loading = false,
  setActiveSession,
}) => {
  const dispatch = useDispatch();

  const [hoveredSessionId, setHoveredSessionId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const sidebarBottomItems = [
    {
      text: "Clear conversations",
      icon: Images.VisionAIBin,
      action: () => setActiveSession(null),
    },
    { text: "Light mode", icon: Images.VisionAIModeSwitch },
    {
      text: "Updates & FAQ",
      icon: Images.VisionAINav1,
    },
  ];

  const handleDeleteChat = () => {
    dispatch(AIAction.deleteAISession({ sessionId }));
    if (sessionId === activeSession) {
      setActiveSession(null);
    }
  };

  return (
    <div
      className={`w-[18.75em] absolute z-[101] left-0 top-0 bg-white h-screen flex flex-col justify-between gap-5`}
    >
      <div className="space-y-4 px-6 py-8 pb-2 h-full">
        <Buttons.GreenGradientButton
          width="full"
          onClick={() => setActiveSession(null)}
        >
          + New Chat
        </Buttons.GreenGradientButton>
        <div className="space-y-2 max-h-[calc(100vh-19em)] overflow-auto">
          {loading ? (
            <Loader.Circular />
          ) : (
            chat?.map((item, index) => (
              <div
                className={`p-1 flex gap-2 items-center rounded-full hover:shadow-sm hover:bg-visionAiNavBG-gradient cursor-pointer ${
                  activeSession === item?.sessionId &&
                  "bg-visionAiNavBG-gradient"
                }`}
                key={index}
                onClick={() => setActiveSession(item?.sessionId)}
                onMouseEnter={() => setHoveredSessionId(item?.sessionId)}
                onMouseLeave={() => setHoveredSessionId(null)}
              >
                <div className="rounded-full w-[2.8em] h-[2.8em] object-cover flex justify-center items-center border border-[#D4D4D4] shadow-visionAiNavShadow bg-visionAiNavBtn-gradient cursor-pointer">
                  <img
                    src={Images.VisionAIChat}
                    className="w-[1.2em] h-[1.2em]"
                  />
                </div>
                <div
                  className="line-clamp-1 text-ellipsis w-[75%]"
                  title={item?.lastMessage}
                >
                  {item?.lastMessage}
                </div>
                {hoveredSessionId === item?.sessionId && (
                  <FaTrash
                    className="pr-1 text-red-500 text-[1.5em]"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSessionId(item?.sessionId);
                      setDeleteModalOpen(true);
                    }}
                  />
                )}
              </div>
            ))
          )}
        </div>
      </div>
      <div className="border-t space-y-4 p-6">
        {sidebarBottomItems.map((item, index) => (
          <div
            className={`p-1 flex gap-3 items-center ${
              item.action && "cursor-pointer"
            } w-max`}
            key={index}
            onClick={item?.action}
          >
            <img src={item?.icon} className="w-[1em] h-[1em]" />

            <div className="line-clamp-1 text-[0.875em]">{item?.text}</div>
          </div>
        ))}
      </div>
      <Modal.DefaultModal
        open={deleteModalOpen}
        onCancel={() => setDeleteModalOpen(false)}
        closable
      >
        <div className="flex flex-col justify-center items-center gap-4 w-[40em]">
          <IoIosAlert className="text-[5em] text-yellow-500" />
          <div className="text-[1.5em] font-semibold">
            Are you sure you want to delete this chat?
          </div>
          <div className="flex gap-3">
            <Buttons.WhiteButton onClick={() => setDeleteModalOpen(false)}>
              Cancel
            </Buttons.WhiteButton>
            <Buttons.RedButton
              onClick={() => {
                handleDeleteChat();
                setDeleteModalOpen(false);
              }}
            >
              Delete
            </Buttons.RedButton>
          </div>
        </div>
      </Modal.DefaultModal>
    </div>
  );
};

export default VisionAISidebar;
